<template>
  <label class="container" v-bind:class="$attrs['class']">
    <input @change="$emit('change', $event)" class="" type="checkbox" v-model="localValue" v-bind="{...$attrs, ...$props}">
    </input>
    <Check class="checkmark" :class="{ hidden: !value }" :size="18"></Check>
  </label>
</template>

<script lang="babel">
import Check from 'vue-material-design-icons/Check';

export default {
  name: "Checkbox",
  components: { Check },
  props: {
    value: {
      required: false
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  cursor: pointer;
}

.container > input {
  display: none;
}

.checkmark {
  display: inline-flex;

  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  border-radius: 6px;

  padding: 2px;
}

::v-deep > .material-design-icon__svg {
  .hidden & {
    opacity: 0;
  }
}

.container > input:checked ~ .checkmark {
  color: #F94848;
}
</style>
